import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { signUp } from '../../store/actions/authActions';
import * as ROUTES from '../../constants/routes';


class SignUp extends Component {
    constructor(props) {
        super();
    }
    
    state = {
        email: "",
        password: "",
        companyName: "",
        companyDescription: "",
        ceoNAME: "",
        noOfEmpl: "",
        website: "",
        twitter: "",
        linkedin: "",
        facebook: "",
        phone: "",
        avatar: "",
        isUploading: false,
        progress: 0,
        avatarURL: ""
    }
    
    handleChange = (e) => {
        this.setState({ [e.target.id]: e.target.value })
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.signUp(this.state);

        console.log(this.state);
    }



    render() {
        const { auth, authError } = this.props;

        if(auth.uid) return <Redirect to={ROUTES.HOME} />

        return (
            <div className="container">
                <div className="credentials-form sign-forms" >

                    <form onSubmit={this.handleSubmit} className="form-group">
                        <h1 className="">Sign Up</h1>
                        <hr />
                        <div className="form-group">
                            <label htmlFor="companyName">Company Name *</label>
                            <input
                                type="text"
                                id="companyName"
                                className="form-control"
                                onChange={this.handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="companyDescription">Company Description *</label>
                            <input
                                type="text"
                                id="companyDescription"
                                className="form-control"
                                onChange={this.handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="ceoNAME">CEO Name *</label>
                            <input
                                type="text"
                                id="ceoNAME"
                                className="form-control"
                                onChange={this.handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="noOfEmpl">Number Of Employees</label>
                            <input
                                type="text"
                                id="noOfEmpl"
                                className="form-control"
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="website">Website</label>
                            <input
                                type="text"
                                id="website"
                                className="form-control"
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="twitter">Twitter</label>
                            <input
                                type="text"
                                id="twitter"
                                className="form-control"
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="linkedin">LinkedIn</label>
                            <input
                                type="text"
                                id="linkedin"
                                className="form-control"
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="facebook">Facebook</label>
                            <input
                                type="text"
                                id="facebook"
                                className="form-control"
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone">Phone *</label>
                            <input
                                type="text"
                                id="phone"
                                className="form-control"
                                onChange={this.handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email *</label>
                            <input
                                type="email"
                                id="email"
                                className="form-control"
                                onChange={this.handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">Password *</label>
                            <input
                                type="password"
                                id="password"
                                className="form-control"
                                onChange={this.handleChange}
                                required
                            />
                        </div>
                        <br />
                        <div className="form-group">
                            <button className="btn btn-primary btn-block btn-custom">Sign Up</button>
                            <div className="red-text center">
                                { authError ? <div className="w-100"><br /><p className="text-center text-danger">{authError}</p></div> :  null }
                            </div>
                        </div>
                    </form> 
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        authError: state.auth.authError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        signUp: (newUser) => dispatch(signUp(newUser)) 
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);